import {
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild,
  afterNextRender,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { HotelsCardComponent } from '../../../hotels-card/hotels-card.component';

@Component({
  selector: 'iho-slider-slidemenu-view',
  standalone: true,
  imports: [CommonModule, SharedModule, HotelsCardComponent],
  templateUrl: './slider-slidemenu-view.component.html',
  styleUrls: ['./slider-slidemenu-view.component.scss'],
})
export class SliderSlidemenuViewComponent {
  @ViewChild('template', { static: true }) template: any;
  sliderConfigs: ISwiperConfigs = {};
  resetSwiper = signal(true);
  configAffordable: any;
  selectedTabName = '';
  tabContent: any;
  @Input()
  get dataSource(): any {
    return this._dataSource;
  }
  set dataSource(value: any) {
    if (this._dataSource === undefined) {
      this._dataSource = value;
      this.handleTabChange('Tehran');
    } else this._dataSource = value;
  }
  private _dataSource: any = undefined;

  constructor(
    private swiperService: SwiperService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    afterNextRender(() => {
      this.resetSwiper.set(false);
      setTimeout(() => this.resetSwiper.set(true), 0);
    });
  }
  ngAfterViewInit(): void {
    let config = {
      slide: 'auto',
      enabled: false,
      clickable: false,
    };

    this.sliderConfigs = {
      swiperConfig: this.swiperService.SwiperConfig(config),
      cardType: 2,
      wrapperClasslist: [
        'flex, items-center, gap-4, lg:-mt-8, lg:col-span-3, xl:col-span-4, max-w-full',
      ],
      wrapperId: 'affordable',
      template: this.template,
    };

    this.handleTabChange('Tehran');
  }

  handleTabChange(tabName: string) {
    this.selectedTabName = tabName;
    this.tabContent = this.dataSource?.Section?.Data?.Details?.find(
      (each: any) => each.NameEn === tabName
    )?.Infos;
  }
}
